import { YoklaAssignment } from '../types';

/**
 * Checks if a question requires special Q26 grading (5 criteria)
 * Conditions: 8–11 grade (11 aktiv = 10 layout), Foreign language, Question 26
 * Sinif həmişə yoxlanılır: apellyasiyada assignment.sinif şagird sənədindən (grade/sinif) set edilməlidir.
 */
export const isQ26SpecialGrading = (assignment: YoklaAssignment | null, questionNumber: string | undefined): boolean => {
  if (!assignment || !questionNumber) return false;

  const normalizedQuestion = questionNumber.replace(/^Q/i, '').trim();
  const normalizedSinif = String(assignment.sinif ?? '').trim();
  const normalizedFenn = String(assignment.fenn || '').trim().toLocaleLowerCase('az');

  // "İngilis dili", "İngilis", "Xarici dil", "Rus", "Alman", "Fransız"
  const isAz = normalizedFenn.includes('azərbaycan') || normalizedFenn.includes('azerbaycan');
  const isXariciDil =
    !isAz &&
    (normalizedFenn.includes('xarici') ||
      normalizedFenn.includes('ingilis') ||
      normalizedFenn.includes('rus') ||
      normalizedFenn.includes('alman') ||
      normalizedFenn.includes('frans') ||
      normalizedFenn.endsWith('dili'));

  // 8, 9, 10, 11 sinif + Xarici dil + Q26 → essay rejimi
  // (11-ci sinif artıq 10-cu sinif blank/sual siyahısı istifadə edir)
  return (
    (normalizedSinif === '8' || normalizedSinif === '9' || normalizedSinif === '10' || normalizedSinif === '11') &&
    isXariciDil &&
    normalizedQuestion === '26'
  );
};
